export default {
  batch: {
    status: "Estado",
    totalDistance: "Distancia total (km)",
    productionEmission: "Emisión de producción (kg CO2e)",
    transportEmission: "Emisión de transporte (kg CO2e)",
    totalEmission: "Emisión total (kg CO2e)",
    tax: "Impuesto (€)",
    more: "Más",
    fallbackDistanceWarning: "Distancia calculada con método alternativo, puede contener errores",
  },
  label: {
    start: "Inicio",
    end: "Fin",
    via: "Vía",
    mode: "Modo de transporte",
    weight: "Peso",
    cnCode: "Código CN",
  },
  placeholder: {
    start: "ej. Shanghái, CN",
    end: "ej. Róterdam, NL",
    via: "ej. Singapur, SG",
    mode: "Modo de transporte",
    weight: "Ingrese el peso",
    cnCode: "ej. 25070080 o cemento",
    location: "ej. Shanghái, CN",
  },
  action: {
    addVia: "Agregar punto intermedio",
    remove: "Eliminar",
    calculate: "Calcular",
    loadMore: "Cargar más",
  },
  transport: {
    sea: "Mar",
    road: "Carretera",
    rail: "Ferrocarril",
    barge: "Barcaza",
  },
  unit: {
    tonne: "Tonelada",
    kilogram: "Kilogramo",
    pound: "Libra",
  },
  leg: {
    enable_detailed_mode: "Habilitar modo detallado para mostrar factores de emisión",
    detailed_mode: "Modo detallado",
    simple_mode: "Modo simple",
    origin: "Origen",
    destination: "Destino",
    transport_mode: "Modo de transporte",
    distance: "Distancia (km)",
    weight: "Peso (t)",
    cn_code: "Código CN",
    transport_emission: "Emisión de transporte (kg CO2e)",
    transport_emission_factor: "Factor de emisión de transporte",
    transport_emission_factor_id: "ID del factor de emisión de transporte",
    production_emission: "Emisión de producción (kg CO2e)",
    production_emission_factor: "Factor de emisión de producción",
    production_emission_factor_id: "ID del factor de emisión de producción",
    total_emission: "Emisión total (kg CO2e)",
  },
  error: {
    cnCodeSearchFailed: "Error en la búsqueda del código CN",
    cnCodeSearchFailedDesc:
      "No se pueden consultar los códigos CN disponibles, por favor verifique la red.",
    locationRequired: "Por favor ingrese una ubicación",
    modeRequired: "Por favor seleccione un modo de transporte",
    requiredFields: "Por favor complete todos los campos obligatorios",
    calculationFailed: "Error en el cálculo",
    checkInputs: "Por favor verifique las entradas o intente nuevamente más tarde",
    cnCodeRequired: "Por favor ingrese el código CN",
    weightRequired: "Por favor ingrese el peso",
    maxViaPoints: "Máximo 3 puntos intermedios permitidos",
    cnCodeInvalid:
      "El código CN solo puede contener letras, números y guiones bajos, máximo 20 caracteres",
    weightPositive: "El peso debe ser positivo",
    locationSearchFailed: "Error en la búsqueda de ubicación",
    locationSearchFailedDesc:
      "No se puede conectar con el servicio de ubicación, por favor intente nuevamente más tarde.",
  },
  result: {
    title: "Resultado del cálculo",
    selected: "Opción seleccionada",
    alternative: "Opción recomendada ({mode})",
    leg: "Tramo {index}",
    totalDistance: "Distancia total",
    productionEmission: "Emisión de producción",
    transportEmission: "Emisión de transporte",
    totalEmission: "Emisión total",
    tax: "Impuesto de carbono",
  },
  page: {
    title: "Calculadora de emisiones CBAM",
    single: "Cálculo individual",
    batchTitle: "Cálculo por lotes",
    batch: {
      rowNumber: "Fila",
      cnCode: "Código CN",
      weight: "Peso (t)",
      originCity: "Ciudad de origen",
      originCoords: "Coordenadas de origen",
      destinationCity: "Ciudad de destino",
      destinationCoords: "Coordenadas de destino",
      transportMode: "Modo de transporte",
      error: "Error",
      errorRowsDetected:
        "{count} filas con errores detectadas, excluidas automáticamente. Solo {validCount} filas válidas guardadas.",
      errors: {
        invalidCsvHeader: "Encabezado CSV inválido",
        headerMustBe: "El encabezado debe ser exactamente: {fields}",
        batchSizeExceed: "El tamaño del lote no puede exceder {maxSize}",
        csvValidationFailed: "Error en la validación del CSV",
        checkFormat: "Verifique el formato o intente nuevamente",
        invalidXlsxFile: "Archivo XLSX inválido",
        fileIsEmpty: "El archivo está vacío",
        invalidXlsxHeader: "Encabezado XLSX inválido",
        xlsxValidationFailed: "Error en la validación del XLSX",
      },
    },
    upgradeTip:
      "¡Actualice a Pro para desbloquear el peso segmentado y el cálculo de código CN y mejorar la precisión del cumplimiento de la CBAM!",
    learnMore: "Más información",
    reportTitle: "Informe de emisiones",
    viewReport: "Ver informe",
    totalOverview: "Resumen total",
    origin: "Origen",
    destination: "Destino",
    totalDistance: "Distancia total",
    tax: "Impuesto",
    basedOnEUR: "Basado en €{amount}",
    productionEmission: "Emisión de producción",
    transportEmission: "Emisión de transporte",
    totalEmission: "Emisión total",
    pleaseCalculateFirst: "Por favor calcule primero",
    batchLimitInfo:
      "Los usuarios gratuitos admiten hasta 10 registros, los usuarios pagadores admiten hasta 200 registros.",
    clearErrorData: "Limpiar datos de error",
    submitCalculation: "Enviar cálculo",
    confirmDeleteTask: "¿Está seguro de que desea eliminar esta tarea?",
    reupload: "Volver a cargar",
    uploadHint: "Haga clic o arrastre el archivo a esta área para cargarlo",
    csvOnlyHint: "La versión gratuita solo admite CSV, los usuarios pagadores admiten CSV y XLSX",
    configFailed: "Error al obtener la configuración, por favor intente nuevamente",
    batchResultSummary: "Total {total} registros, {success} exitosos, {fail} fallidos",
    searchByCNCode: "Buscar por código CN",
    downloadCSVTemplate: "Descargar plantilla CSV",
    downloadXLSXTemplate: "Descargar plantilla XLSX",
    previewReport: "Vista previa del informe",
    to: "a",
    // Traducciones relacionadas con plantillas
    template: {
      saveTemplate: "Guardar plantilla",
      templateName: "Nombre de la plantilla",
      namePlaceholder: "Por favor ingrese el nombre de la plantilla",
      nameRequired: "Por favor ingrese el nombre de la plantilla",
      nameTooLong: "El nombre de la plantilla no puede exceder los 50 caracteres",
      formIncomplete: "Por favor complete el formulario antes de guardar la plantilla",
      saveSuccess: "Plantilla guardada con éxito",
      saveFailed: "Error al guardar la plantilla",
    },
  },
  tooltip: {
    cnCode: "El código CN consta de letras, números y guiones bajos, hasta 20 caracteres",
  },
  progress: {
    title: "Cálculo por lotes",
    stages: {
      connecting: "Conectando",
      connected: "Conectado",
      validating: "Validando",
      validated: "Validado",
      calculating: "Calculando",
      completed: "Cálculo completado",
    },
    close: "Cerrar",
    regenerate: "Regenerar",
    addFactor: "Agregar factor",
  },
  location: {
    noMatch: "No hay resultados coincidentes",
    enterKeyword: "Por favor ingrese una palabra clave",
  },
  plan: {
    trialExceeded: "Cálculos de prueba excedidos ({count})",
    trialExpired: "Período de prueba expirado",
    monthlyExceeded: "Cálculos mensuales excedidos ({count})",
    subscriptionExpired: "Período de suscripción expirado",
  },
};
